import { render, staticRenderFns } from "./GoogleBusinessIcon.vue?vue&type=template&id=3e67e5e4"
import script from "./GoogleBusinessIcon.vue?vue&type=script&lang=js"
export * from "./GoogleBusinessIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports